import { getLocalStorageItem } from '../../utils/local-storage';

export type FeatureToggleName = 'themeToggle' | 'detailsAndUsage' | 'devTools';

type FeatureToggleValue = Partial<Record<FeatureToggleName, boolean>>;

type Configuration = {
  name: FeatureToggleName;
  description: string;
};

export const FEATURE_TOGGLE_CONFIGURATION: Configuration[] = [
  {
    name: 'themeToggle',
    description: 'Theme toggle',
  },
  {
    name: 'detailsAndUsage',
    description: 'Plan details and usage',
  },
];

if (process.env.REACT_APP_MODE === 'development') {
  FEATURE_TOGGLE_CONFIGURATION.push({
    name: 'devTools',
    description: 'Turn on development tools',
  });
}

export const allFeatureToggles: FeatureToggleValue = FEATURE_TOGGLE_CONFIGURATION.reduce((allFeatures, feature) => {
  return { ...allFeatures, [feature.name]: JSON.parse(getLocalStorageItem(feature.name) ?? 'false') };
}, {});

// TODO: Temporary - LSPRO-3511
export const MULTILANG_SRT_NOT_AVAILABLE_FOR = [
  'mJBlPxoAiwYXS4WgIRiCr', // BMW Group Prod
  'kDAZDZtK4Pf91vYe4a5mk', // BMW Group Test
  'BS1GCd0rvAkCOLOjxgjiV', // BMW Group Dealer
  'VozcfFLisyctwDZ1CwShc', // BMW Group Dealer Test
  'ERy4Y9VU4YNPw6tJvKJQh', // movingimage QA
];

// TODO: Temporary, will be removed and integrated with BE in LSPRO-3425
export const PRELIVE_CHAT_ENABLED_WEBCASTS = [
  'RtYjxTSxxY4KeB9HNh5n6', // lsproId: g1OHJ9vmJHOpVkpAOL1gp
  'VCJ8vR4JdGO0kg0FHV9aw', // lsproId: g1OHJ9vmJHOpVkpAOL1gp
  '4xrw8TKQK2y0sqEutvxui', // movingimage QA
];
